// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Navbar from './components/Navbar';
import Nav from './components/Nav';
import Home from './components/Home';
import About from './components/About';
import Demo from './components/Demo';
import Blogs from './components/Blogs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import AdminLayout from './components/admin/AdminLayout';
import StoreRequests from './components/admin/StoreRequests';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLeads from './components/admin/AdminLeads';
import SupportTickets from './components/admin/SupportTickets';
import Payments from './components/admin/Payments';
import ContentSubmissions from './components/admin/ContentSubmissions';
import Customers from './components/admin/Customers';

// Wrapper component to conditionally show Navbar and Footer
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <div className="App">
      {!isAdminRoute && <Nav />}
      <main className={`main-content ${isAdminRoute ? 'admin-mode' : ''}`}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/demo" element={
            <Navigate to="https://demo-site.creativepulse.pk/" replace />
          } />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Admin Login - Separate route */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Admin Panel Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="store-requests" element={<StoreRequests />} />
            <Route path="store-requests/:id" element={<StoreRequests />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="payments" element={<Payments />} />
            <Route path="content-submissions" element={<ContentSubmissions />} />
            <Route path="support-tickets" element={<SupportTickets />} />
            <Route path="stores" element={<div>Active Stores - Coming Soon</div>} />
            <Route path="customers" element={<div>Customers - Coming Soon</div>} />
            <Route path="settings" element={<div>Settings - Coming Soon</div>} />
            <Route path="customers" element={<Customers />} />
          </Route>
          
          {/* 404 Page */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;